import React, { useState, useEffect, useContext } from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Container } from '@material-ui/core';
import CertificatesService from '../../services/certificates.service';
import TextfieldGeneral from '../FormsUI/TextfieldGeneral';
import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from "store/ToastContext";
import TextfieldIpAddress from '../FormsUI/TextfieldIpAddress';


export default function NewCeritificatePopup(props) {    
    const { openToast } = useContext(ToastContext);        
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    
    useEffect(() => {
            
    }, [])    

    const handleSubmit = async (values) => {                        
        try {            
            setSpinnerLoading(true);
            var certificate = await CertificatesService.createCertificate(values);
            
            if (certificate.errorCodes[0] === null)             
                openToast("New certificate was created succussfully", "success");                             
            else if (certificate == null)
                openToast("The IP address resolved from host name, is not in the WAF list", "error");
            else
                openToast("An error occured during creating a new certificate: " + certificate.errorCodes[0].description, "error");
                
            setSpinnerLoading(false);                     
        } catch (error) {
            
        }
        
        props.setShowAddModal(false);
    }   

    return (
        <Grid container>
            <Grid item xs={12}>
                <Container maxWidth="md">
                    <div>
                        <Formik
                            initialValues={{ 
                            hostName: '',
                            ipAddress: ''                                
                            }}                                
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(true);
                                handleSubmit(values);
                            }}
                            validationSchema={Yup.object().shape({
                                hostName: Yup.string().required('Host Name is required')
                                    .matches(/^(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/i, 'Invalid host name format'),
                                ipAddress: Yup.string().required('IP Address is required')
                                    .matches(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, "Invalid IP address format")                             
                            })}
                        >
                        {(props) => {
                            const {                
                                handleSubmit
                            } = props;
                            return (
                                <Form onSubmit={handleSubmit} noValidate>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextfieldGeneral name="hostName" label="Host Name" size="small" inputProps={{maxLength: 255}} id="hostName" InputLabelProps={{id:"hostName"}}></TextfieldGeneral>
                                        </Grid>
                                        <Grid item xs={12}>                                        
                                            <TextfieldIpAddress name="ipAddress" label="IP Address" size="small" inputProps={{maxLength: 15}} id="ipAddress" InputLabelProps={{id: "ipAddress"}}></TextfieldIpAddress>                                            
                                        </Grid>
                                        <Grid container className="mb-2 px-2">
                                            <Grid item xs={12}>
                                                <AppButton id="createCertificateBtn" 
                                                    type="submit" 
                                                    isLoading={spinnerLoading} 
                                                    label="SUBMIT" 
                                                    isBlock={true}>
                                                </AppButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )
                            }}
                        </Formik>
                    </div>
                </Container>
            </Grid>
        </Grid>    
    )
}